import { Component } from '@angular/core';

@Component({
  templateUrl: 'addrepoagent2.component.html'
})
export class Addrepoagent2Component {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/agencies/addrepoagent2.component.ts